/* eslint-disable indent */
/*
 *
 * App reducer
 *
 */

import { fromJS } from "immutable";
import { isTokenExpired } from "utils/helperFunctions";
import {
  GET_BILLING_INFO_ERROR,
  GET_BILLING_INFO_SUCCESS,
  GET_COMPANY_INFO_SUCCESS,
  LOAD_SEARCH_FILTER_OPTIONS_SUCCESS,
  LOGIN,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  SHOW_SESSION_EXPIRATION_MODAL,
  REFRESH_USER_DATA_SUCCESS,
  REFRESH_USER_DATA_ERROR,
  UPDATE_USER_DATA,
  SHOW_LINKEDIN_AUTHORIZE_MODAL,
  LINKEDIN_INTEGRATION_ERROR,
  GET_LOGIN_TOKEN_LINKEDIN,
  REMOVE_LOGIN_TOKEN_LINKEDIN,
  PARTNERS_LOGIN,
  PARTNERS_LOGIN_ERROR,
  PARTNERS_LOGIN_SUCCESS,
  REMOVE_FILTER,
  REMOVE_RESET_PASSWORD_FLAG,
  GET_ROLES_SUCCESS,
  RESET_IDS,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  PARTNERS_FORGOT_PASSWORD_SUCCESS,
  PARTNERS_FORGOT_PASSWORD_ERROR,
  RESET_REFRESH_PAGE,
  RESET_SCHEDULING_JOB_DETAIL_ID,
  RESET_SEARCH_FILTERS,
  SET_CURRENT_CANDIDATE_ID,
  SET_CURRENT_JOB_DETAIL_ID,
  SET_REFRESH_PAGE,
  SET_SCHEDULING_JOB_DETAIL_ID,
  SET_USER_INPUT,
  SET_ZR_JOB,
  UPDATE_PAID_THIS_SESSION,
  UPDATE_SEARCH_FILTERS,
  SET_NEW_PASSWORD,
  SET_NEW_PASSWORD_SUCCESS,
  SET_NEW_PASSWORD_ERROR,
  PARTNERS_SET_NEW_PASSWORD_ERROR,
  PARTNERS_SET_NEW_PASSWORD_SUCCESS,
  GET_INVOICE_PRICING_SUCCESS,
  GET_INVOICE_PRICING_ERROR,
  SET_FROM_SEARCH_FLAG,
  SAVE_LAST_LOCATION,
  CLEAR_RESET_PASSWORD_ERRORS,
  UPDATE_COMPANY_DEFAULT_PIPELINE_ID,
  GET_USERS_SUCCESS,
  GET_SOURCES_SUCCESS,
  CREATE_SOURCE_SUCCESS,
  SHOW_NEW_JOB_MODAL,
  UPDATE_COMPANY_INFO,
  GET_IDENTITY_PROVIDER,
  GET_IDENTITY_PROVIDER_SUCCESS,
  SSO_LOGIN_SUCCESS,
  SSO_LOGIN_ERROR,
  RESET_ERROR_CODE,
  SETUP_FEATURE_FLAGS,
  UPDATE_SOURCES_BY_LOCALE,
  SET_ORDER_IN_PROCESS,
  RESET_ORDER_IN_PROCESS,
  DELETE_CANDIDATE_SUCCESS,
  DELETE_CANDIDATE_ERROR,
  RESET_DELETE_CANDIDATE_SUCCESS,
  UPDATE_VHS,
  SET_CURRENT_VIDEO_INTERVIEW_TEMPLATE_ID,
  RESET_CURRENT_VIDEO_INTERVIEW_TEMPLATE_ID,
  GET_DYNAMIC_SCORE_REPORTS_DATA,
  GET_DYNAMIC_SCORE_REPORTS_DATA_SUCCESS,
  GET_DYNAMIC_SCORE_REPORTS_DATA_ERROR,
  FORCE_LOGOUT,
  CLEAR_FORCE_LOGOUT,
  SET_JOB_CREATION_INFO,
  GET_DYNAMIC_SCORE_REPORTS_WORK_STYLES_SUCCESS,
  GET_DYNAMIC_SCORE_REPORTS_WORK_STYLES_ERROR,
  GET_TEST_BATTERIES_SUCCESS,
  SET_VI_MERCHANDISING_MODAL,
  SET_INTERVIEW_TEMPLATE_CREATION_INFO,
  RESET_INTERVIEW_TEMPLATE_CREATION_INFO,
  SEND_SUPPORT_BOT_QUESTION,
  SEND_SUPPORT_BOT_QUESTION_SUCCESS,
  SEND_SUPPORT_BOT_QUESTION_ERROR,
  RESET_SUPPORT_BOT_RESPONSE,
  GET_CANDIDATE_ANALYTICS_SUCCESS,
  GET_PREV_CANDIDATE_ANALYTICS_SUCCESS,
  GET_ASSESSMENT_ANALYTICS_SUCCESS,
  GET_PREV_ASSESSMENT_ANALYTICS_SUCCESS,
  GET_STRUCTURED_INTERVIEW_ANALYTICS_SUCCESS,
  GET_SCORE_RANGE_ANALYTICS_SUCCESS,
  GET_SCORE_RANGE_ANALYTICS_ERROR,
  GET_BUSINESS_VALUE_SUCCESS,
  SET_ANALYTICS_REQUESTED,
  CLEAR_CUSTOM_DATE_ANALYTICS,
  CHECK_VALID_VERIFY_TOKEN,
  CHECK_VALID_VERIFY_TOKEN_SUCCESS,
  CHECK_VALID_VERIFY_TOKEN_ERROR,
  RESEND_VERIFICATION_EMAIL,
  RESEND_VERIFICATION_EMAIL_SUCCESS,
  SET_PASSWORD,
  SET_PASSWORD_SUCCESS,
  SET_PASSWORD_ERROR,
} from "./constants";

const initialSearchFilters = fromJS({
  jobTitle: null,
  state: null,
  city: null,
  zipcode: null,
  country: null,
  applicationFilterId: null,
  applicationFilterType: null,
  applicationFilterName: null,
  fromDate: null,
  toDate: null,
  sourceId: null,
  sourceName: null,
  eventStatus: null,
  stageName: null,
  labelId: null,
  ratingType: null,
  ratingValue: null,
  searchText: null,
  firstName: null,
  lastName: null,
  email: null,
  testTakerId: null,
});

const initialState = fromJS({
  userData: null,
  currentJobDetailId: null,
  currentStageToShow: null,
  schedulingJobDetailId: null,
  currentCandidateId: null,
  fromSearch: false,
  refreshPage: false,
  searchFilters: initialSearchFilters,
  searchFilterOptions: {
    jobTitles: {},
    locations: {},
    applicationFilters: {},
    ratings: {},
    sources: {},
    labels: {},
  },
  hireBlind: null,
  errorCode: null,
  partnersErrorCode: null,
  partnersResetEmailSent: false,
  showPartnersForgotPasswordErrorMessage: false,
  ssoError: null,
  resetEmailSent: false,
  paidThisSession: false,
  vhs: null,
  currentSearchText: "",
  companyInfo: {},
  roles: {},
  zipRecruiterJobDetailId: null,
  zrLink: null,
  billingInfo: {},
  invoicePricing: null,
  showNewPasswordErrorMessage: false,
  showPartnersNewPasswordErrorMessage: false,
  newPasswordErrorMessage: "",
  resetPassword: false,
  partnersResetPassword: false,
  lastLocation: "",
  billingInfoLoaded: false,
  activeUsers: {},
  inactiveUsers: {},
  showNewJobModal: false,
  sources: [
    { title: "Social Links", suggestions: ["Facebook", "LinkedIn", "Twitter"] },
    {
      title: "Job Boards",
      suggestions: [
        "AngelList",
        "Beyond.com",
        "CareerBuilder",
        "Careerjet",
        "CBCJobs",
        "Coroflot",
        "Craigslist",
        "Dice",
        "Doostang",
        "Dribbble",
        "GitHub",
        "Glassdoor",
        "Indeed",
        "InHerSight",
        "JobInventory",
        "Jooble",
        "Juju",
        "LookSharp",
        "Monster",
        "The Muse",
        "Naukri",
        "Oodle",
        "Recruit.net",
        "Seek",
        "Simply Hired",
        "StackOverflow",
        "Switch",
        "Totaljobs",
        "Trovit",
        "Workopolis",
        "Xing",
        "ZipRecruiter",
      ],
    },
  ],
  identityProviderMode: null,
  allowPassword: null,
  identityProviderInfo: {
    identityProviderName: "",
    cognitoBaseUrl: "",
    clientId: "",
    redirectUri: "",
    scopes: [],
    auth0: [],
    mfaEnabled: null,
    isVerified: null,
  },
  identityProviderStatus: "idle",
  featureFlags: {},
  orderInProcess: false,
  linkedInUserEmail: "",
  linkedInIntegrationErrorMessage: "",
  showLinkedInAuthorizeModal: false,
  showLinkedInIntegrationErrorModal: false,
  loginToken: "",
  deleteCandidateSuccess: false,
  deletedCandidateId: [],
  currentVideoInterviewTemplateId: null,
  showSessionExpirationModal: false,
  loginLoading: false,
  forceLogout: false,
  dynamicScoreReportsData: {},
  dynamicScoreReportsDataLoaded: false,
  dynamicScoreReportsError: "",
  dynamicScoreReportsSource: null,
  dynamicScoreReportsTestEventId: null,
  dynamicScoreReportsUserAccountId: null,
  dynamicScoreReportsWorkStylesData: {},
  dynamicScoreReportsWorkStylesLoaded: false,
  dynamicScoreReportsWorkStylesError: false,
  hasNewTalentInsightsFlagEnabled: false,
  requestedDynamicScoreReportsData: false,
  jobCreationInfo: {},
  hasCreatedTestBatteries: false,
  showVIMerchandisingModal: null,
  interviewTemplateCreationInfo: {},
  sendingBotQuestion: false,
  supportBotResponse: "",
  supportBotResponseError: false,
  trackResponseId: "",
  analyticsData: {}, // holds analytics data keyed by date filter
  analyticsRequested: [], // tracks analytics date filters requested
  showUserVerified: false,
  verifyLinkInvalid: false,
  resendVerificationEmailSuccess: false,
  checkValidVerifyTokenLoading: false,
  setNewPasswordLoading: false,
  setPasswordLoading: false,
});

// default param working as intended - does not need to be last
// eslint-disable-next-line default-param-last
function appReducer(state = initialState, action) {
  switch (action.type) {
    case SET_USER_INPUT:
      return state.setIn([...action.field], action.value);
    case SET_CURRENT_JOB_DETAIL_ID: {
      if (action.stage !== undefined) {
        return state
          .set("currentJobDetailId", action.jobDetailId)
          .set("currentStageToShow", action.stage);
      }
      return state.set("currentJobDetailId", action.jobDetailId);
    }
    case SET_SCHEDULING_JOB_DETAIL_ID:
      return state.set("schedulingJobDetailId", action.jobDetailId);
    case RESET_SCHEDULING_JOB_DETAIL_ID:
      return state.set("schedulingJobDetailId", null);
    case SET_CURRENT_CANDIDATE_ID:
      return state.set("currentCandidateId", action.candidateId);
    case RESET_IDS:
      return state
        .set("currentJobDetailId", null)
        .set("currentCandidateId", null)
        .set("currentStageToShow", null)
        .set("fromSearch", false);
    case SET_FROM_SEARCH_FLAG:
      return state.set("fromSearch", true);
    case SET_REFRESH_PAGE:
      return state.set("refreshPage", true);
    case RESET_REFRESH_PAGE:
      return state.set("refreshPage", false);
    case RESET_SEARCH_FILTERS:
      return state
        .set("searchFilters", initialSearchFilters)
        .set("currentSearchText", "");
    case LOAD_SEARCH_FILTER_OPTIONS_SUCCESS:
      return state
        .setIn(
          ["searchFilterOptions", "jobTitles"],
          fromJS(action.options.data.jobTitles)
        )
        .setIn(
          ["searchFilterOptions", "locations"],
          fromJS(action.options.data.locations)
        )
        .setIn(
          ["searchFilterOptions", "applicationFilters"],
          fromJS(action.options.data.applicationFilters)
        )
        .setIn(
          ["searchFilterOptions", "ratings"],
          fromJS(action.options.data.ratings)
        )
        .setIn(
          ["searchFilterOptions", "sources"],
          fromJS(action.options.data.sources)
        )
        .setIn(
          ["searchFilterOptions", "labels"],
          fromJS(action.options.data.labels)
        )
        .set("hireBlind", action.options.data.hireBlind);

    case UPDATE_SEARCH_FILTERS:
      return state
        .setIn(["searchFilters", "searchText"], action.formData.searchText)
        .setIn(["searchFilters", "jobTitle"], action.formData.jobTitle)
        .setIn(["searchFilters", "city"], action.formData.city)
        .setIn(["searchFilters", "state"], action.formData.state)
        .setIn(["searchFilters", "zipcode"], action.formData.zipcode)
        .setIn(["searchFilters", "country"], action.formData.country)
        .setIn(["searchFilters", "fromDate"], action.formData.fromDate)
        .setIn(["searchFilters", "toDate"], action.formData.toDate)
        .setIn(["searchFilters", "ratingType"], action.formData.ratingType)
        .setIn(["searchFilters", "ratingValue"], action.formData.ratingValue)
        .setIn(
          ["searchFilters", "applicationFilterId"],
          action.formData.applicationFilterId
        )
        .setIn(
          ["searchFilters", "applicationFilterType"],
          action.formData.applicationFilterType
        )
        .setIn(
          ["searchFilters", "applicationFilterName"],
          action.formData.applicationFilterName
        )
        .setIn(["searchFilters", "sourceId"], action.formData.sourceId)
        .setIn(["searchFilters", "sourceName"], action.formData.sourceName)
        .setIn(["searchFilters", "stageName"], action.formData.stageName)
        .setIn(["searchFilters", "eventStatus"], action.formData.eventStatus)
        .setIn(["searchFilters", "labelId"], action.formData.labelId)
        .setIn(["searchFilters", "labelName"], action.formData.labelName)
        .setIn(["searchFilters", "testTakerId"], action.formData.testTakerId);
    case REMOVE_FILTER:
      if (action.filterName === "location") {
        return state
          .setIn(["searchFilters", "city"], null)
          .setIn(["searchFilters", "state"], null)
          .setIn(["searchFilters", "zipcode"], null)
          .setIn(["searchFilters", "country"], null);
      }
      if (action.filterName === "label") {
        return state
          .setIn(["searchFilters", "labelId"], null)
          .setIn(["searchFilters", "labelName"], null);
      }
      if (action.filterName === "ratings") {
        return state
          .setIn(["searchFilters", "ratingType"], null)
          .setIn(["searchFilters", "ratingValue"], null);
      }
      if (action.filterName === "applicationFilter") {
        return state
          .setIn(["searchFilters", "applicationFilterId"], null)
          .setIn(["searchFilters", "applicationFilterType"], null)
          .setIn(["searchFilters", "applicationFilterName"], null);
      }
      if (action.filterName === "searchText") {
        return state
          .setIn(["searchFilters", "searchText"], null)
          .set("currentSearchText", null);
      }
      if (action.filterName === "sources") {
        return state
          .setIn(["searchFilters", "sourceId"], null)
          .setIn(["searchFilters", "sourceName"], null);
      }
      return state.setIn(["searchFilters", action.filterName], null);
    case LOGIN:
      return state.set("loginLoading", true);
    case LOGIN_SUCCESS:
      return state
        .set("errorCode", null)
        .set("ssoError", null)
        .set("featureFlags", action.configCatObject)
        .set("vhs", action.userData.hsVersion)
        .set("userData", action.userData)
        .set("showSessionExpirationModal", false)
        .set("loginLoading", false)
        .set("forceLogout", false);
    case LOGIN_ERROR:
      return state
        .set("errorCode", action.errorCode)
        .set("ssoError", null)
        .set("loginLoading", false);
    case SHOW_SESSION_EXPIRATION_MODAL:
      return state.set("showSessionExpirationModal", isTokenExpired());
    case REFRESH_USER_DATA_SUCCESS:
      return state.set("userData", action.userData);
    case REFRESH_USER_DATA_ERROR:
      return state.set(
        "errorMessage",
        "User Data cannot be retrieved. Please login again."
      );
    case UPDATE_USER_DATA:
      return state.set("userData", {
        ...state.get("userData"),
        ...action.userData,
      });
    case SHOW_LINKEDIN_AUTHORIZE_MODAL:
      return state
        .set("showLinkedInAuthorizeModal", true)
        .set("loginToken", action.token)
        .set("linkedInUserEmail", action.userEmail);
    case LINKEDIN_INTEGRATION_ERROR:
      return state
        .set("linkedInUserEmail", action.userEmail)
        .set("linkedInIntegrationErrorMessage", action.error)
        .set("showLinkedInIntegrationErrorModal", true);
    case GET_LOGIN_TOKEN_LINKEDIN:
      return state.set("loginToken", action.token);
    case REMOVE_LOGIN_TOKEN_LINKEDIN:
      return state.set("loginToken", "");
    case PARTNERS_LOGIN:
      return state.set("partnersErrorCode", false);
    case PARTNERS_LOGIN_SUCCESS:
      return state
        .set("partnersErrorCode", null)
        .set("userData", action.userData);
    case PARTNERS_LOGIN_ERROR:
      return state.set("partnersErrorCode", action.errorCode);
    case RESET_PASSWORD_SUCCESS:
      return state.set("resetEmailSent", true);
    case RESET_PASSWORD_ERROR:
      return state.set(("resetEmailSent", true));
    case PARTNERS_FORGOT_PASSWORD_SUCCESS:
      return state
        .set("partnersResetEmailSent", true)
        .set("showPartnersForgotPasswordErrorMessage", false);
    case PARTNERS_FORGOT_PASSWORD_ERROR:
      return state
        .set("partnersResetEmailSent", false)
        .set("showPartnersForgotPasswordErrorMessage", action.err);
    case CLEAR_RESET_PASSWORD_ERRORS:
      return state.set("resetEmailSent", false);
    case UPDATE_PAID_THIS_SESSION:
      return state.set("paidThisSession", true);
    case REMOVE_RESET_PASSWORD_FLAG:
      return state.set("resetEmailSent", false);
    case GET_COMPANY_INFO_SUCCESS:
      return state
        .set("companyInfo", fromJS(action.companyInfo))
        .set("vhs", fromJS(action.companyInfo.hsVersion));
    case GET_ROLES_SUCCESS:
      return state.set("roles", fromJS(action.roles));
    case SET_ZR_JOB:
      return state
        .set("zipRecruiterJobDetailId", action.jobDetailId)
        .set("zrLink", action.zrLink);
    case GET_BILLING_INFO_SUCCESS:
      return state
        .set("billingInfo", fromJS(action.billingInfo.billing || {}))
        .set("pricing", fromJS(action.billingInfo.pricing))
        .set("billingInfoLoaded", true);
    case GET_BILLING_INFO_ERROR:
      return state;
    case SET_NEW_PASSWORD:
      return state.set("setNewPasswordLoading", true);
    case SET_NEW_PASSWORD_SUCCESS:
      return state
        .set("resetPassword", true)
        .set("setNewPasswordLoading", false);
    case SET_NEW_PASSWORD_ERROR:
      return state.set("setNewPasswordLoading", false);
    case PARTNERS_SET_NEW_PASSWORD_ERROR:
      return state.set("showPartnersNewPasswordErrorMessage", true);
    case PARTNERS_SET_NEW_PASSWORD_SUCCESS:
      return state.set("partnersResetPassword", true);
    case GET_INVOICE_PRICING_SUCCESS:
      return state.set("invoicePricing", action.invoicePricing);
    case GET_INVOICE_PRICING_ERROR:
      return state;
    case SAVE_LAST_LOCATION:
      return state.set("lastLocation", action.pathname);
    case UPDATE_COMPANY_DEFAULT_PIPELINE_ID:
      return state
        .setIn(["companyInfo", "defaultPipelineId"], action.pipelineId)
        .setIn(
          ["companyInfo", "pipelineStageMapId"],
          action.pipelineStageMapId
        );
    case GET_DYNAMIC_SCORE_REPORTS_DATA: {
      return state.set("requestedDynamicScoreReportsData", true);
    }
    case GET_DYNAMIC_SCORE_REPORTS_DATA_SUCCESS: {
      const { dynamicScoreReportsData, testEventId, source, userAccountId } =
        action;
      return state
        .set("dynamicScoreReportsData", fromJS(dynamicScoreReportsData))
        .set("dynamicScoreReportsDataLoaded", true)
        .set("dynamicScoreReportsTestEventId", testEventId)
        .set("dynamicScoreReportsSource", source || null)
        .set("dynamicScoreReportsUserAccountId", userAccountId || null);
    }
    case GET_DYNAMIC_SCORE_REPORTS_DATA_ERROR: {
      return state.set("dynamicScoreReportsError", fromJS(action.errorMsg));
    }
    case GET_USERS_SUCCESS:
      return state
        .set("activeUsers", fromJS(action.activeUsers))
        .set("inactiveUsers", fromJS(action.inactiveUsers));
    case GET_SOURCES_SUCCESS: {
      const sourcesObj = { title: "Custom Sources", suggestions: [] };
      if (action.sources) {
        action.sources.forEach((sourceObj) => {
          if (
            !state
              .get("sources")
              .get(0)
              .get("suggestions")
              .includes(sourceObj.sourceName) &&
            !state
              .get("sources")
              .get(1)
              .get("suggestions")
              .includes(sourceObj.sourceName)
          ) {
            sourcesObj.suggestions.push(sourceObj.sourceName);
          }
        });
        const sortedCustomSources = sourcesObj.suggestions.sort((a, b) =>
          a.toLowerCase() > b.toLowerCase() ? 1 : -1
        );
        sourcesObj.suggestions = sortedCustomSources;
        return state.setIn(["sources", 2], fromJS(sourcesObj));
      }
      return state;
    }
    case CREATE_SOURCE_SUCCESS: {
      const sourcesObj = {
        title: "Custom Sources",
        suggestions: state.get("sources").get(2)
          ? state.get("sources").get(2).get("suggestions").toJS()
          : [],
      };
      if (
        !state
          .get("sources")
          .get(0)
          .get("suggestions")
          .includes(action.source.sourceName) &&
        !state
          .get("sources")
          .get(1)
          .get("suggestions")
          .includes(action.source.sourceName) &&
        state.get("sources").get(2) &&
        !state
          .get("sources")
          .get(2)
          .get("suggestions")
          .includes(action.source.sourceName)
      ) {
        sourcesObj.suggestions.push(action.source.sourceName);
      }
      const sortedCustomSources = sourcesObj.suggestions.sort((a, b) =>
        a.toLowerCase() > b.toLowerCase() ? 1 : -1
      );
      sourcesObj.suggestions = sortedCustomSources;
      return state.setIn(["sources", 2], fromJS(sourcesObj));
    }
    case SHOW_NEW_JOB_MODAL:
      return state.set("showNewJobModal", action.value);
    case UPDATE_COMPANY_INFO:
      return state.setIn(["companyInfo", action.field], action.value);
    case GET_IDENTITY_PROVIDER:
      return state
        .set("identityProviderMode", null)
        .set("allowPassword", null)
        .set(
          "identityProviderInfo",
          fromJS({
            identityProviderName: "",
            cognitoBaseUrl: "",
            clientId: "",
            redirectUri: "",
            scopes: [],
            isVerified: null,
          })
        )
        .set("identityProviderStatus", "loading");
    case GET_IDENTITY_PROVIDER_SUCCESS: {
      const isVerified = action.identityProviderData.verifiedAt !== null;

      return state
        .set(
          "identityProviderMode",
          action.identityProviderData.identityProviderMode
        )
        .set("allowPassword", action.identityProviderData.allowPassword)
        .set(
          "identityProviderInfo",
          action.identityProviderData.identityProviderMode !== 0
            ? fromJS({
                identityProviderName:
                  action.identityProviderData.identityProviderName,
                cognitoBaseUrl: action.identityProviderData.cognitoBaseUrl,
                clientId: action.identityProviderData.clientId,
                redirectUri: action.identityProviderData.redirectUri,
                scopes: action.identityProviderData.scopes,
                auth0: action.identityProviderData.auth0,
                mfaEnabled: action.identityProviderData.mfaEnabled,
                isVerified,
              })
            : fromJS({
                identityProviderName: "",
                cognitoBaseUrl: "",
                clientId: "",
                redirectUri: "",
                scopes: [],
                auth0: action.identityProviderData.auth0 || [],
                mfaEnabled: action.identityProviderData.mfaEnabled,
                isVerified,
              })
        )
        .set("identityProviderStatus", "success");
    }
    case SSO_LOGIN_SUCCESS:
      return state
        .set("errorCode", null)
        .set("ssoError", null)
        .set("featureFlags", action.configCatObject)
        .set("vhs", action.userData.hsVersion)
        .set("userData", action.userData);
    case SSO_LOGIN_ERROR:
      // the ssologin endpoint will return an array as the error, if the error is sso-related,
      // or an opbject containing an error code, if the error is hs-related (ie: suspended account)
      if (Array.isArray(action.error)) {
        return state
          .set("ssoError", fromJS(action.error))
          .set("errorCode", null);
      }
      return state.set("errorCode", action.error).set("ssoError", null);
    case UPDATE_SOURCES_BY_LOCALE: {
      const auSourceList = [
        "Adzuna",
        "APS Jobs",
        "CareerOne",
        "Craigslist",
        "Dribbble",
        "GitHub",
        "Glassdoor",
        "GradConnection",
        "Gumtree",
        "Indeed",
        "JobActive",
        "Jora",
        "Monster",
        "Seek",
        "StackOverflow",
        "Trovit",
        "Workopolis",
        "Xing",
        "ZipRecruiter",
      ];
      return state.setIn(["sources", 1, "suggestions"], fromJS(auSourceList));
    }
    case RESET_ERROR_CODE:
      return state.set("errorCode", null).set("ssoError", null);
    case SETUP_FEATURE_FLAGS: {
      const featureFlagMap = fromJS(action.configCatObject);
      return state.set("featureFlags", featureFlagMap);
    }
    case SET_ORDER_IN_PROCESS:
      return state.set("orderInProcess", true);
    case RESET_ORDER_IN_PROCESS:
      return state.set("orderInProcess", false);
    case DELETE_CANDIDATE_SUCCESS: {
      // because the ResultsLanding > RecentCandidates component needs the deleted candidate Id to force a manual update to match the deletion
      // we have to save the candidate ID in the parent component(App), and from here pass it down to ResultsLanding > RecentCandidates
      // and because the users can delete more than one candidate on Results screen, we use an array to store the ID(s)
      const deletedCandidateIdCopy = state
        .get("deletedCandidateId")
        .toJS()
        .slice();
      deletedCandidateIdCopy.push(action.currentCandidateId);

      return state
        .set("deleteCandidateSuccess", true)
        .set("deletedCandidateId", fromJS(deletedCandidateIdCopy));
    }
    case DELETE_CANDIDATE_ERROR: {
      return state;
    }
    case RESET_DELETE_CANDIDATE_SUCCESS:
      return state.set("deleteCandidateSuccess", false);
    case UPDATE_VHS:
      return state.set("vhs", action.vhs);
    case SET_CURRENT_VIDEO_INTERVIEW_TEMPLATE_ID:
      return state.set("currentVideoInterviewTemplateId", action.templateId);
    case RESET_CURRENT_VIDEO_INTERVIEW_TEMPLATE_ID:
      return state.set("currentVideoInterviewTemplateId", null);
    case FORCE_LOGOUT:
      return initialState.set("forceLogout", true);
    case CLEAR_FORCE_LOGOUT:
      return state.set("forceLogout", false);
    case SET_JOB_CREATION_INFO:
      return state.set("jobCreationInfo", action.jobCreationInfo);
    case GET_DYNAMIC_SCORE_REPORTS_WORK_STYLES_SUCCESS: {
      return state
        .set(
          "dynamicScoreReportsWorkStylesData",
          fromJS(action.dynamicScoreReportsWorkStylesData)
        )
        .set("dynamicScoreReportsWorkStylesLoaded", true);
    }
    case GET_DYNAMIC_SCORE_REPORTS_WORK_STYLES_ERROR:
      return state.set("dynamicScoreReportsWorkStylesError", true);
    case GET_TEST_BATTERIES_SUCCESS: {
      const hasCreatedTestBatteries = Object.values(action.testBatteries).some(
        (testBattery) => testBattery.userAccountId !== 0
      );
      return state.set("hasCreatedTestBatteries", hasCreatedTestBatteries);
    }
    case SET_VI_MERCHANDISING_MODAL:
      return state.set("showVIMerchandisingModal", action.value);
    case SET_INTERVIEW_TEMPLATE_CREATION_INFO:
      return state.set(
        "interviewTemplateCreationInfo",
        action.interviewTemplateCreationInfo
      );
    case RESET_INTERVIEW_TEMPLATE_CREATION_INFO:
      return state.set("interviewTemplateCreationInfo", {});
    case SEND_SUPPORT_BOT_QUESTION:
      return state
        .set("sendingBotQuestion", true)
        .set("supportBotResponseError", false);
    case SEND_SUPPORT_BOT_QUESTION_SUCCESS:
      return state
        .set("sendingBotQuestion", false)
        .set("supportBotResponse", action.response.answer)
        .set("trackResponseId", action.response.responseId);
    case SEND_SUPPORT_BOT_QUESTION_ERROR:
      return state
        .set("sendingBotQuestion", false)
        .set("supportBotResponseError", true)
        .set("supportBotResponse", "");
    case RESET_SUPPORT_BOT_RESPONSE:
      return state
        .set("sendingBotQuestion", false)
        .set("supportBotResponse", "")
        .set("trackResponseId", "")
        .set("supportBotResponseError", false);
    case GET_CANDIDATE_ANALYTICS_SUCCESS:
    case GET_PREV_CANDIDATE_ANALYTICS_SUCCESS: {
      const { data, dateFilter, dataType } = action;

      if (!data) {
        return state;
      }

      return state.setIn(
        ["analyticsData", dateFilter, "candidateCounts", dataType],
        data.totalCandidateCount
      );
    }
    case GET_ASSESSMENT_ANALYTICS_SUCCESS: {
      const { data, dateFilter, dataType } = action;

      if (!data) {
        return state;
      }

      return state
        .setIn(
          ["analyticsData", dateFilter, "assessmentCounts", dataType],
          data.totalAssessmentCount
        )
        .setIn(
          ["analyticsData", dateFilter, "assessmentCounts", "totalCandidates"],
          data.totalCandidateCount // Only for this specific case
        );
    }

    case GET_PREV_ASSESSMENT_ANALYTICS_SUCCESS: {
      const { data, dateFilter, dataType } = action;

      if (!data) {
        return state;
      }

      return state.setIn(
        ["analyticsData", dateFilter, "assessmentCounts", dataType],
        data.totalAssessmentCount
      );
    }

    case GET_STRUCTURED_INTERVIEW_ANALYTICS_SUCCESS: {
      const { data, dateFilter } = action;

      if (!data) {
        return state;
      }

      return state
        .setIn(
          ["analyticsData", dateFilter, "structuredInterviewCounts", "vi"],
          fromJS({
            total: data.totalVideoInterviews.totalVICount,
            prevTotal: data.prevTotalVideoInterviews.totalVICount,
          })
        )
        .setIn(
          ["analyticsData", dateFilter, "structuredInterviewCounts", "li"],
          fromJS({
            total: data.totalLiveInterviews.totalLICount,
            prevTotal: data.prevTotalLiveInterviews.totalLICount,
          })
        );
    }
    case GET_SCORE_RANGE_ANALYTICS_SUCCESS: {
      const { data, dateFilter } = action;

      if (!data) {
        return state;
      }

      return state.setIn(
        ["analyticsData", dateFilter, "scoreRangesMet"],
        fromJS(data)
      );
    }
    case GET_SCORE_RANGE_ANALYTICS_ERROR:
      return state.setIn(
        ["analyticsData", action.dateFilter, "scoreRangesMet"],
        "error"
      );
    case GET_BUSINESS_VALUE_SUCCESS: {
      const { data, dateFilter } = action;
      const { businessValue, daysSinceFirstEvent } = data;

      return state.setIn(
        ["analyticsData", dateFilter, "businessValueData"],
        fromJS({ businessValue, daysSinceFirstEvent })
      );
    }
    case SET_ANALYTICS_REQUESTED:
      return state.set(
        "analyticsRequested",
        state.get("analyticsRequested").push(action.dateFilter)
      );
    case CLEAR_CUSTOM_DATE_ANALYTICS:
      return state.deleteIn(["analyticsData", "custom"]);
    case CHECK_VALID_VERIFY_TOKEN:
      return state.set("checkValidVerifyTokenLoading", true);

    case CHECK_VALID_VERIFY_TOKEN_SUCCESS: {
      const { data } = action;
      const showUserVerified = data.verifiedAt !== null;

      return state
        .set("verifyLinkInvalid", false)
        .set("showUserVerified", showUserVerified)
        .set("checkValidVerifyTokenLoading", false);
    }
    case CHECK_VALID_VERIFY_TOKEN_ERROR: {
      const { errorData } = action;
      const showUserVerified = errorData?.verifiedAt !== null;

      return state
        .set("verifyLinkInvalid", true)
        .set("showUserVerified", showUserVerified)
        .set("checkValidVerifyTokenLoading", false);
    }
    case RESEND_VERIFICATION_EMAIL:
      return state.set("resendVerificationEmailSuccess", false);
    case RESEND_VERIFICATION_EMAIL_SUCCESS:
      return state.set("resendVerificationEmailSuccess", true);
    case SET_PASSWORD:
      return state.set("setPasswordLoading", true);
    case SET_PASSWORD_SUCCESS:
      return state.set("setPasswordLoading", false);
    case SET_PASSWORD_ERROR:
      return state.set("setPasswordLoading", false);
    default:
      return state;
  }
}

export default appReducer;
